import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { loadStripe } from "@stripe/stripe-js";
import { Elements, PaymentElement, CardElement, useStripe, useElements, IbanElement } from "@stripe/react-stripe-js";
import styled from 'styled-components';
import Formsy, { withFormsy } from 'formsy-react'; // Import withFormsy

import ActionButton from 'SharedComponents/action-button';
import TextInput from 'SharedComponents/text-input';
import PopoverHover from 'SharedComponents/popover-hover';
import { min, update } from "lodash";

import log from "Utils/logger";

import styles from './index.css.js';


const PaymentStripeWrapper = styled.section`${styles}`;

//const stripePromise = loadStripe("your_stripe_public_key");
const stripePromise = loadStripe("pk_test_51QyonQB3ewwWcxNwMso2X2DyZnT533o8B9BqDQbBaSdXrN99fZ5jnmb2bPNu4b5COkH9wuV2woAC8kxioMIjRVLw00A0wzgHeY");

//const user = useSelector(state => state.authentication.user);

const TextInputWithFormsy = withFormsy(TextInput);

const CheckoutForm = ({ clientSecret }) => {
    const stripe = useStripe();
    const elements = useElements();
    
    const user = useSelector(state => state.authentication.user);
    
    //const selectedPlan = useSelector(state => state.subscriptions.availSubscriptionPlans.find(plan => plan.subscriptionOptionSelected === true));
    const selectedPlan = useSelector(state => {
        const availablePlans = state.subscriptions.availSubscriptionPlans;
        return availablePlans.find(plan => plan.subscriptionOptionSelected === true) || availablePlans[0] || null;
    });
      

    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [quantity, setQuantity] = useState(10);
    //const [planCost, setPlanCost] = useState(selectedPlan.subscriptionAmount); // not sure if this is needed
    
    const [totalCost, setTotalCost] = useState(selectedPlan.subscriptionAmount * quantity);
    const [companyName, setCompanyName] = useState('');

    const [name, setName] = useState(user?.shopper_fname || '');
    const [email, setEmail] = useState(user?.shopper_email || '');


    useEffect(() => {
        //console.log('SelectSubscriptionPlan useEffect triggered with subscriptionPlans: ', subscriptionPlans);
    
        console.log('CheckoutForm - mounted');

        return (() => {
          console.log('CheckoutForm - unmounted');
        });
      }, []);

    useEffect(() => {
        //test useEffect Only
        console.log('useEffect payment-stripe update to totalCost:', totalCost);
        console.log('useEffect payment-stripe update to totalCost selectedPlan:', selectedPlan);

    }, [totalCost]);

    useEffect(() => {
        setName(user?.shopper_fname || ''); // Update when user changes
        setEmail(user?.shopper_email || ''); // Update when user changes
    }, [user]);

    useEffect(() => {
        console.log('useEffect payment-stripe update to selectedPlan:', selectedPlan);
        //setPlanCost(selectedPlan.subscriptionAmount);
        setTotalCost(selectedPlan.subscriptionAmount * quantity);
        //console.log('useEffect payment-stripe update to planCost:', planCost);
        //console.log('useEffect payment-stripe update to totalCost:', totalCost);
    }, [selectedPlan]);

    const updateQuantity = (e) => {
        setQuantity(e.target.value);
        setTotalCost(selectedPlan.subscriptionAmount * e.target.value);
    }

    const updateCompanyName = (e) => {
        setCompanyName(e.target.value);
    }

    const updateName = (e) => {
        setName(e.target.value);
    }

    const updateEmail = (e) => {
        setEmail(e.target.value);
    }
    //const [clientSecret, setClientSecret] = useState("sk_test_51QyonQB3ewwWcxNwwVN4OrRGDEXQTac3qnzSULu4SE9kQ4eWLnLFsdMPiVAGdddsuDXR0c9DovoalAPkROi5JDRM00tloO2msk"); // Simulated test clientSecret


    /* const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");

        try {
            const response = await fetch("/api/create-payment-intent", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ amount: 50 }), // Replace with dynamic amount
            });

            if (!response.ok) {
                throw new Error("Failed to create payment intent");
            }

            const { clientSecret } = await response.json();

            const { error, paymentIntent } = await stripe.confirmPayment({
                elements,
                confirmParams: {
                    return_url: window.location.href,
                },
            });

            if (error) {
                throw new Error(error.message);
            }

            if (paymentIntent && paymentIntent.status === "succeeded") {
                setMessage("Payment successful!");
            }
        } catch (error) {
            setMessage(error.message || "Payment failed. Try again.");
        } finally {
            setLoading(false);
        }
    }; */

    const temporaryRenderUntilFormReady = () => {
        return (
        <Formsy
            style={{ width: 'calc(100% - 20px)', padding: '0px 10px' }}
        >
            <div className="input-fields-container">
                
                <TextInputWithFormsy
                    name="Quantity"
                    id="quanity"
                    type="tel"
                    validations={{ 
                    isExisty: true,
                    //maxLength: 3,
                    minValue: (values, value) => value !== '' && value >= 1,  // Ensure value is at least 0
                    maxValue: (values, value) => value !== '' && value <= 1000, 
                    matchRegexp: /^\d+$/
                    }}
                    validationErrors={{
                    isExisty: 'This field is required',
                    maxValue: 'Please contact accounts@boostsuper.com.au for more than 1000 employees',
                    minValue: 'Available for 5 employees or more',
                    matchRegexp: 'Only numbers allowed'
                    }}
                    required
                    value={quantity}
                    onChange={updateQuantity}
                    labelStyle={{ margin: '0 0 -5px 0' }}
                    //placeholder="First Name"
                    label={
                    <div className='input-label-with-info'>
                        Quantity (No of employees) {/* <span className="tooltip-container"><div className="tooltip-icon">i</div><span className="tooltip"><div className="content">You can use the following as a guide: Cash = 2.7%, Conservative=3.8%, Moderate = 4.4%, Balanced = 4.8%, Growth = 5%, High Growth = 5.3%</div></span></span></div> */}
                        <span className="pop-over-container">
                        <PopoverHover
                        content={
                            <div style={{
                            maxWidth: '300px', padding: 10, fontSize: '16px', fontWeight: 'bold', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', flexDirection: 'column', textAlign: 'left',
                            }}
                            >
                            Enter quantity of employees you would like to subscribe to this plan.
                            </div>
                        }
                        header = {null}
                        img = {null}
                        itemToPopover = {
                            ( <i className="material-icons" style={{ margin: '0 5px 0 5px', fontSize:'20px', color:'#000'}} >info</i> )
                        }
                        anchorOrigin={{
                            vertical: 'center',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'center',
                            horizontal: 'right',
                        }}
                        />
                    </span>
                    </div>
                    }
                />
            </div>
            <h3>Total Cost: ${totalCost.toFixed(2)}</h3>
            
            <div className="next-steps">
                <p style={{ fontStyle: "italic", fontSize: "14px", margin: "5px 0px"}}>Email us the quantity you want to purchase at accounts@boostyoursuper.com.au . We shall then send you an invoice. Once the invoice is paid we email you a receipt and Employer Code to share with your employees.</p>
            </div>
            
            {message && <p>{message}</p>}
            {/* </form> */}
        </Formsy>
        );
    }

    // Full form with all fields. Will need card working before can be used and storing employee details.
    const fullForm = () => {
        <Formsy
            style={{ width: 'calc(100% - 20px)', padding: '0px 10px' }}
        >
            <div className="input-fields-container">
                <TextInputWithFormsy
                    name="Company Name"
                    id="company-name"
                    type="text"
                    validations={{ 
                    isExisty: true,
                    minLength: 2,
                    maxLength: 50,
                    matchRegexp: /^[a-zA-Z0-9&\s-]+$/,
                    }}
                    validationErrors={{
                        isExisty: 'This field is required',
                        minLength: "Company name must be at least 2 characters",
                        maxLength: "Company name must be less than 50 characters",
                        matchRegexp: "Only letters, numbers, spaces, '&', and '-' are allowed",
                    }}
                    required
                    value={companyName}
                    onChange={updateCompanyName}
                    //placeholder="First Name"
                    labelStyle={{ margin: '0 0 -5px 0' }}
                    label={
                    <div className='input-label-with-info'>
                        Enter company name {/* <span className="tooltip-container"><div className="tooltip-icon">i</div><span className="tooltip"><div className="content">You can use the following as a guide: Cash = 2.7%, Conservative=3.8%, Moderate = 4.4%, Balanced = 4.8%, Growth = 5%, High Growth = 5.3%</div></span></span></div> */}
                        <span className="pop-over-container">
                        <PopoverHover
                        content={
                            <div style={{
                            maxWidth: '300px', padding: 10, fontSize: '16px', fontWeight: 'bold', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', flexDirection: 'column', textAlign: 'left',
                            }}
                            >
                            Name of the company you are purchasing subscriptions for.
                            </div>
                        }
                        header = {null}
                        img = {null}
                        itemToPopover = {
                            ( <i className="material-icons" style={{ margin: '0 5px 0 5px', fontSize:'20px', color:'#000'}} >info</i> )
                        }
                        anchorOrigin={{
                            vertical: 'center',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'center',
                            horizontal: 'right',
                        }}
                        />
                    </span>
                    </div>
                    }
                />

                <TextInputWithFormsy
                    name="Your Name"
                    id="name"
                    type="text"
                    validations={{ 
                    isExisty: true,
                    minLength: 2,
                    maxLength: 50,
                    matchRegexp: /^[a-zA-Z0-9&\s-]+$/,
                    }}
                    validationErrors={{
                        isExisty: 'This field is required',
                        minLength: "Your name must be at least 2 characters",
                        maxLength: "Your name must be less than 50 characters",
                        matchRegexp: "Only letters, numbers, spaces, '&', and '-' are allowed",
                    }}
                    required
                    value={name}
                    onChange={updateName}
                    //placeholder="First Name"
                    labelStyle={{ margin: '0 0 -5px 0' }}
                    label={
                    <div className='input-label-with-info'>
                        Enter your name {/* <span className="tooltip-container"><div className="tooltip-icon">i</div><span className="tooltip"><div className="content">You can use the following as a guide: Cash = 2.7%, Conservative=3.8%, Moderate = 4.4%, Balanced = 4.8%, Growth = 5%, High Growth = 5.3%</div></span></span></div> */}
                        <span className="pop-over-container">
                        <PopoverHover
                        content={
                            <div style={{
                            maxWidth: '300px', padding: 10, fontSize: '16px', fontWeight: 'bold', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', flexDirection: 'column', textAlign: 'left',
                            }}
                            >
                            Enter your name.
                            </div>
                        }
                        header = {null}
                        img = {null}
                        itemToPopover = {
                            ( <i className="material-icons" style={{ margin: '0 5px 0 5px', fontSize:'20px', color:'#000'}} >info</i> )
                        }
                        anchorOrigin={{
                            vertical: 'center',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'center',
                            horizontal: 'right',
                        }}
                        />
                    </span>
                    </div>
                    }
                />
                <div className="email-with-confirmation">
                    <TextInputWithFormsy
                        name="Your Email"
                        id="shopper-email"
                        type="email"
                        validations={{
                            isEmail: true, 
                            isExisty: true,
                            isDefaultRequiredValue: 'this field is required',
                            minLength: 2,
                            maxLength: 50,
                            matchRegexp: /^(((?!(info@|admin@|web@|support@)).)*)$/,
                        }}
                        validationErrors={{
                            isEmail: 'The email is invalid',
                            isExisty: 'This field is required',
                            isDefaultRequiredValue: 'this field is required',
                            minLength: "Your email must be at least 2 characters",
                            maxLength: "Your email must be less than 50 characters",
                            matchRegexp: "Role based emails are disallowed",
                        }}
                        required
                        value={email}
                        onChange={updateEmail}
                        //placeholder="First Name"
                        labelStyle={{ margin: '0 0 -5px 0' }}
                        label={
                        <div className='input-label-with-info'>
                            Enter your email {/* <span className="tooltip-container"><div className="tooltip-icon">i</div><span className="tooltip"><div className="content">You can use the following as a guide: Cash = 2.7%, Conservative=3.8%, Moderate = 4.4%, Balanced = 4.8%, Growth = 5%, High Growth = 5.3%</div></span></span></div> */}
                            <span className="pop-over-container">
                            <PopoverHover
                            content={
                                <div style={{
                                maxWidth: '300px', padding: 10, fontSize: '16px', fontWeight: 'bold', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', flexDirection: 'column', textAlign: 'left',
                                }}
                                >
                                Email where employer code will be dispatched to.
                                </div>
                            }
                            header = {null}
                            img = {null}
                            itemToPopover = {
                                ( <i className="material-icons" style={{ margin: '0 5px 0 5px', fontSize:'20px', color:'#000'}} >info</i> )
                            }
                            anchorOrigin={{
                                vertical: 'center',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'center',
                                horizontal: 'right',
                            }}
                            />
                        </span>
                        </div>
                        }
                    />
                    <div className="action-button-holder" style={{ width: "70px", padding: "12px 10px 0 10px"}}>
                        <ActionButton
                            text="Confirm Email"
                            onClick={(e) => e.preventDefault()} //() =>  handleSubmit()}
                            color="#fff"
                            small={true}
                            disabled={!stripe || !clientSecret || loading}
                        />
                    </div>
                </div>

                <TextInputWithFormsy
                    name="Quantity"
                    id="quanity"
                    type="tel"
                    validations={{ 
                    isExisty: true,
                    //maxLength: 3,
                    minValue: (values, value) => value !== '' && value >= 1,  // Ensure value is at least 0
                    maxValue: (values, value) => value !== '' && value <= 1000, 
                    matchRegexp: /^\d+$/
                    }}
                    validationErrors={{
                    isExisty: 'This field is required',
                    maxValue: 'Please contact accounts@boostsuper.com.au for more than 1000 employees',
                    minValue: 'Available for 5 employees or more',
                    matchRegexp: 'Only numbers allowed'
                    }}
                    required
                    value={quantity}
                    onChange={updateQuantity}
                    labelStyle={{ margin: '0 0 -5px 0' }}
                    //placeholder="First Name"
                    label={
                    <div className='input-label-with-info'>
                        Quantity (No of employees) {/* <span className="tooltip-container"><div className="tooltip-icon">i</div><span className="tooltip"><div className="content">You can use the following as a guide: Cash = 2.7%, Conservative=3.8%, Moderate = 4.4%, Balanced = 4.8%, Growth = 5%, High Growth = 5.3%</div></span></span></div> */}
                        <span className="pop-over-container">
                        <PopoverHover
                        content={
                            <div style={{
                            maxWidth: '300px', padding: 10, fontSize: '16px', fontWeight: 'bold', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', flexDirection: 'column', textAlign: 'left',
                            }}
                            >
                            Enter quantity of employees you would like to subscribe to this plan.
                            </div>
                        }
                        header = {null}
                        img = {null}
                        itemToPopover = {
                            ( <i className="material-icons" style={{ margin: '0 5px 0 5px', fontSize:'20px', color:'#000'}} >info</i> )
                        }
                        anchorOrigin={{
                            vertical: 'center',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'center',
                            horizontal: 'right',
                        }}
                        />
                    </span>
                    </div>
                    }
                />
            </div>
            <h3>Total Cost: ${totalCost.toFixed(2)}</h3>
            {/* <form onSubmit={(e) => e.preventDefault()} className="payment-form"> */}
            <CardElement className="card-element" />
            <IbanElement className="iban-element" />
            {clientSecret ? <PaymentElement className="payment-element" /> : <p>Loading payment options...</p>}
            
            <div className="payment-actions">
                <div className="action-button-holder">
                    <ActionButton
                        text="Pay Now"
                        onClick={(e) => e.preventDefault()} //() =>  handleSubmit()}
                        color="#fff"
                        large={true}
                        disabled={!stripe || !clientSecret || loading}
                        width="180px"
                    />
                </div>
                <p>or</p>
                <div className="action-button-holder">
                    <ActionButton
                        text="Generate Invoice"
                        onClick={(e) => e.preventDefault()} //() =>  handleSubmit()}
                        color="#fff"
                        large={true}
                        disabled={!stripe || !clientSecret || loading}
                        width="180px"
                    />
                {/* <div className="action-button-label">
                        Invoice will be sent to {user.shopper_email}
                    </div> */}
                </div>
            </div>
            <div className="next-steps">
                <p style={{ fontStyle: "italic", fontSize: "14px", margin: "5px 0px"}}>Once funds received, we email you a receipt and Employer Code to share with your employees.</p>
            </div>
            
            {message && <p>{message}</p>}
            {/* </form> */}
        </Formsy>
    }



    return (
        temporaryRenderUntilFormReady()
    );
};

const PaymentStripe = () => {
    const [clientSecret, setClientSecret] = useState("pi_1234567890abcdef_secret_ABC123"); // Simulated test clientSecret

    const options = {
        clientSecret: clientSecret,
    };

    return (
        
            clientSecret && (
                <PaymentStripeWrapper>
                    <Elements stripe={stripePromise} options={options}>
                        <CheckoutForm
                            clientSecret={clientSecret}
                        />
                    </Elements>
                </PaymentStripeWrapper>
            )
        
        
    );
};

export default PaymentStripe;
